import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptVendorNewAndOldStats } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import CardDashboardStatGroup from '@components/card/CardDashboardStatGroup'
import { Num, ThY } from '@utils/utils'
import Stat from '@components/chart/Stat'
import Chart from 'react-google-charts'
import { ColumnChartOptions } from '@components/chart/setting'

const VendorNewAndOldStats = ({ title, data }: { title: string; data: IResponseOptVendorNewAndOldStats }) => {
  const options = ColumnChartOptions('มูลค่าโครงการ', 'ปีงบประมาณ')
  const chartData = [
    [
      'ปีงบประมาณ',
      'ผู้ค้าเก่า',
      { type: 'string', role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ผู้ค้าใหม่',
      { type: 'string', role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
    ],
    ...data.map((item) => {
      const row: (string | number | null)[] = [String(ThY(item.budget_year))]
      const factors: Partial<Record<keyof IResponseOptVendorNewAndOldStats[number], string>> = {
        total_old_vendors: 'ผู้ค้าเก่า',
        total_new_vendors: 'ผู้ค้าใหม่',
      }
      ;(Object.keys(factors) as (keyof IResponseOptVendorNewAndOldStats[number])[]).forEach((factor) => {
        row.push(parseFloat(String(item[factor])))
        row.push(Num(item[factor]))
        row.push(`<div style="padding:8px; width: 280px">
        <strong>ปีงบประมาณ ${ThY(item.budget_year)}</strong><br/>
        <strong>${factors[factor]}</strong><br/>
        จำนวนผู้ค้า : ${Num(item[factor])} คน<br/>
      </div>`)
      })

      return row
    }),
  ]

  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      {data.map((result, index) => {
        return (
          <CardDashboardStatGroup key={result.budget_year}>
            <Stat w={150} label={index > 0 ? '' : 'ปีงบประมาณ'} value={ThY(result.budget_year)} />
            <Stat
              w={250}
              label={index > 0 ? '' : 'จำนวนผู้ค้าทั้งหมด'}
              value={Num(result.total_vendors)}
              unit="หน่วยงาน"
              diff={result.total_vendors_diff}
            />
            <Stat
              w={320}
              label={index > 0 ? '' : 'จำนวนผู้ค้าเก่า'}
              value={Num(result.total_old_vendors) + ` (${result.percentage_old_vendors}%)`}
              unit="หน่วยงาน"
              diff={result.total_old_vendors_diff}
            />
            <Stat
              w={320}
              label={index > 0 ? '' : 'จำนวนผู้ค้าใหม่'}
              value={Num(result.total_new_vendors) + ` (${result.percentage_new_vendors}%)`}
              unit="หน่วยงาน"
              diff={result.total_new_vendors_diff}
            />
          </CardDashboardStatGroup>
        )
      })}
      <Chart width={'100%'} height={'500px'} chartType="ColumnChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default VendorNewAndOldStats
